import { render, staticRenderFns } from "./subjectmarks.vue?vue&type=template&id=3b37eee8&"
import script from "./subjectmarks.vue?vue&type=script&lang=js&"
export * from "./subjectmarks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports